import {useState,useEffect,useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import { manufacturerServices } from '../../services/manufacturerServices';
import {Titlebar,Searchbox, Confirmdelete} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Dialog } from 'primereact/dialog';
import {localurl} from '../../constant';
import {convertFileToBase64} from '../../helpers/base64conversion';
import { Toast } from "primereact/toast";
import { freightServices } from '../../services/freightServices';
import { MultiSelect } from 'primereact/multiselect';

const Freight = () =>{

    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(false);
    const [visible,setVisible] = useState(false);
    const [popvisible,setPopvisible] = useState(false);
    const [deleleteid,setDeleleteid] = useState(false);
    const [viewmanufacturer,setViewmanufacturer] = useState([]);
    const [viewvisible,setViewvisible] = useState(false);
    const toast = useRef(null);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5); // 🔄 dynamic page size
    const [viewdata, setViewdata] = useState([]); // 🔄 dynamic page size




  useEffect(()=>{
      getfreight(currentPage,pageSize);
    },[currentPage,pageSize,viewdata]); 

  useEffect(() => {
      setColDefs(getColDefs(currentPage, pageSize));
  }, [currentPage, pageSize,viewdata]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const deletefreight = (id) =>{
         setPopvisible(true);
         setDeleleteid(id);
      }

const getColDefs = (currentPage, pageSize) => [
  {
    headerName: "SR NO",
    width:100,
    valueGetter: (params) => {
      return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
    },
  },
  { headerName: "Name", field: "name" },
  { headerName: "Contact Person", field: "contact_person" },
  { headerName: "Email", field: "email" },
  { headerName: "Phone", field: "phone" },
  { headerName: "Address", field: "address" },
  // {
  //   headerName: "Status",
  //   field: "status",
  //   cellRenderer: (params) =>
  //     params.value === "active" ? "Active" : "Inactive",
  // },
  {
    headerName: "Action",
    cellStyle: {
       display:'flex',
       justifyContent:'center'
    },
    cellRenderer: (params) => (
      <>
        <button
          className="btn btn-xs btn-primary"
          onClick={() => editredirect(params.data.id, params.data)}
        >
          <i className="icon icon-note"></i>
        </button>
        &nbsp;
        {/* <button
          className="btn btn-danger btn-xs"
          onClick={() => deletefreight(params.data.id)}
        >
          <i className="icon icon-trash"></i>
        </button> */}
        &nbsp;
        <button
          className="btn btn-success btn-xs"
          onClick={() => viewfreightdata(params.data)}
        >
          <i className="icon icon-eye"></i>
        </button>
      </>
    ),
  },
];

const [colDefs, setColDefs] = useState(getColDefs(1, 5));

const editredirect = (id,Data) =>{
  navigate(`/freight_edit/${id}`, { state: { freight: Data } });
}

const viewfreightdata = (Data) =>{
  setViewdata(Data);
  setViewvisible(true);
}

const getfreight  = (page,pageSize)=> {
  console.warn(page,pageSize);
        setUserloaded(true);
        freightServices.getallfreight(page,pageSize).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
                setTotalRows(response.data.total);
                setCurrentPage(response.data.current_page);
                setUserloaded(false);
            }else{
                setResults([]);
                setUserloaded(false);
            }  
        }).catch((error)=>{
          setResults([]);
          setUserloaded(false);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addmanufacturer');
  }

  // const uploadmanufacturer = async (e) =>{
  //    e.preventDefault(); 
  //    let file =  e.target.file.files[0];
  //    const base64 = await convertFileToBase64(file);
  //    supplierservices.createmultisupplier(base64).then((response)=>{

  //    }).catch((error)=>{
       
  //    });        
  // }

  // const viewfreightdata = (id) =>{
  //       manufacturerServices.getmanufacturer(id).then((response)=>{
  //         if(response.status == 200){
  //           setViewmanufacturer(response.data.data);
  //           setViewvisible(true);
  //         }
  //     }).catch((error)=>{
        
  //     }); 
  //  }

  const deletefreightdata = () => {
          if(deleleteid){
          manufacturerServices.deletefreight(deleleteid).then((response)=>{
          if(response.status == 200){
            setPopvisible(false);
            setDeleleteid(false);
            toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Manufacturer deleted successfully' }); 
            getfreight(currentPage,pageSize);   
          }
      }).catch((error)=>{
        
      }); 
          }

  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getfreight(1, newSize);       // reload with new size
  };

  const canceldiag = () =>{
      setPopvisible(false);
  }

  return(
       <>
       <Toast ref={toast} />
          {/* <Bredcrum title={'Freight Providers'} divider={false}/> */}
        <Confirmdelete popvisible={popvisible} deletefun={deletefreightdata} cancel={canceldiag} title="Freight" />
          

    <Dialog 
      header="Freight Data View"
      visible={viewvisible}
      style={{ width: '60vw' }}
      onHide={() => setViewvisible(false)}
      // footer={footerContent}
      modal
      className="p-fluid"
    >
      <div className="card-body">
        <div className="container mt-4">
              <div className="row" >
                          <div class="row mb-3">
                              <div class="col-md-6">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" placeholder="Enter Name" value={viewdata.name} readOnly/>
                              </div>
                            <div className="col-md-6">
                              <label htmlFor="type" className="form-label">Services Type</label>
                                <div className="p-0">
                                  <MultiSelect
                                    id="type"
                                    value={viewdata.types}
                                    options={viewdata.types}
                                    optionLabel="name"
                                    filter
                                    placeholder="Select Services"
                                    className="w-100"
                                    display="chip" 
                                    readOnly
                                    // or "comma", based on design
                                  />
                                </div>
                                {/* {errors.type && <span style={{ color: "red" }}>{errors.type}</span>} */}
                              </div>
                            
                          </div>

                          <div class="row mb-3">
                              <div class="col-md-6">
                                <label for="contact_person" class="form-label">Contact Person</label>
                                <input type="text"  class="form-control"
                                id="contact_person" name="contact_person"  value={viewdata.contact_person} readOnly/>
                              </div>

                          <div class="col-md-6">
                              <label for="email" class="form-label">Email</label>
                              <input type="email" class="form-control" 
                              id="email" name="email" placeholder="Enter email"  value={viewdata.email} readOnly/>
                          </div>
        
                          </div>

                          <div class="row mb-3">
                              <div class="col-md-6">
                                <label for="phone" class="form-label">Phone</label>
                                <input type="number" placeholder="Enter Phone Number" class="form-control" id="phone" 
                                name="phone"   value={viewdata.phone} readOnly/>
                              </div>
                              <div class="col-md-6">
                                <label for="address" class="form-label">Address</label>
                                <textarea class="form-control" placeholder="address"  value={viewdata.address} readOnly></textarea>
                              </div>

                          </div>

                </div>
        
        </div>
      </div>
    </Dialog>

          <div class="row">
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                     <div className=''>
                         <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-4 pe-4' onClick={() => navigate('/freight_add')}>Add Freight Providers</button> 
                         &nbsp;
                         &nbsp;
                         &nbsp; 

                <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => {if (!visible) return; setVisible(false); }}>
                  <div className="container py-5">
                    <div className="card shadow-lg rounded-4 p-4">
                      <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

                      <div className="text-center mb-4">
                        <a
                          href={localurl + "/templates/component.xlsx"}
                          download
                          className="btn btn-outline-primary rounded-pill px-4"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download Excel Template
                        </a>
                      </div>
{/* 
                      <form id="uploadForm" onSubmit={(e) => uploadmanufacturer(e)}>
                        <div className="mb-3">
                          <label htmlFor="file" className="form-label fw-semibold">
                            Upload Excel File
                          </label>
                          <input
                            type="file"
                            className="form-control form-control-lg"
                            id="file"
                            name="file"
                            accept=".xlsx, .xls"
                            required
                          />
                        </div>

                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary rounded-pill px-5 py-2 custom-btn-color"
                          >
                            Upload
                          </button>
                        </div>
                      </form> */}

                      <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
                    </div>
                  </div>

              </Dialog>
                  </div>
                  <Searchbox 
                  value={quickFilterText}
                    onChange={(e) => setQuickFilterText(e.target.value)}
                  />
              </div> 
              </div> 
             
              
              {/* <Titlebar text={'Freight Providers List'}/> */}
              <div className="col-md-12 mt-3">
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded} 
                     quickFilterText={quickFilterText}  paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                     totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext} 
                     handlePrevious={handlePrevious}
                     handlePageSizeChange={handlePageSizeChange}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Freight;